<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-10">
            <page-loading v-if="!billing"></page-loading>
            <template v-else>
                <group-billing-details
                    v-show="hash === 'billing-details' || !hash"
                    :teamId="props.teamId"
                    :groupId="props.groupId"
                    :billing="billing"
                    :isAdminOrOwner="isAdminOrOwner"
                />

                <group-proforma-invoices
                    v-if="billing.is_billable"
                    v-show="hash === 'proforma-invoices'"
                    :teamId="props.teamId"
                    :groupId="props.groupId"
                    :paymentTermsDays="billing.payment_terms_days"
                />

                <group-historical-invoices
                    v-show="hash === 'historical-invoices'"
                    :teamId="props.teamId"
                    :groupId="props.groupId"
                />
            </template>
        </div>
    </page-container>
</template>

<script setup>
import GroupBillingDetails from '~/components/settings/teams/groups/billing/GroupBillingDetails.vue';
import GroupProformaInvoices from './GroupProformaInvoices.vue';
import GroupHistoricalInvoices from './GroupHistoricalInvoices.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import SettingsSidebar from '../menus/SettingsSidebar.vue';
import { ref, onMounted } from 'vue';
import { groupBillingClient } from '~/services';
import { useSettingsHash } from '~/composables/useSettingsHash';

const { hash, content } = useSettingsHash();

const billing = ref(null);

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
});

const isAdminOrOwner = Spark.isAdminOrOwner || ['admin', 'owner'].includes(Spark.roleOnCurrentGroup);

onMounted(async () => {
    try {
        const response = await groupBillingClient.getBillingDetails(props.teamId, props.groupId);
        billing.value = response.data;
    } catch (error) {
        console.error('Failed to fetch billing details:', error);
    }
});
</script>
